export default () => `
<div class="small-container1 all-products-container ">
        <div class="row1 row5">
            <h2>All Products</h2>
            <select class="select">
            <option value="select-price-low" id="disabled">Sort</option>
            <option value="select-price-low">Price (Low-High)</option>
            <option value="select-price-high">Price (High-Low)</option>
            </select>
        </div>
        <div class="row1 products-center">

        </div>
            <div class="pages-btn">
                <span>1</span>
                <span>2</span>
                <span>3</span>
                <span>4→</span>
            </div>
            </div>
            `;
